import Cookies from 'universal-cookie'
import { checkIsLvAdmin, checkIsRm } from '../../helpers/checkAgentTags'
import { getDeviceType } from '../../helpers/utility'
import get from 'lodash/get'
import { LOGIN_AS_GURDIAN } from '../../constants/cookies'

const cookies = new Cookies()

export function retryWithInterval(send, { maxRetries = 15, intervalMs = 200 } = {}) {
  let retries = 0
  const interval = setInterval(() => {
    retries += 1
    if (send() || retries > maxRetries) {
      clearInterval(interval)
    }
  }, intervalMs)
}

export function getDeviceByScreenSize() {
  const width = window.innerWidth
  switch (true) {
    case width < 768:
      return 'mobile'
    case width >= 768 && width < 992:
      return 'tablet'
    default:
      return 'desktop'
  }
}

export function getSourceString() {
  const deviceType = getDeviceType()

  if (deviceType === 'website') {
    return 'Web'
  }

  // for ios / android (or any future app types)
  return 'Apps'
}

export const getAgentType = (agentData) => {
  const agentTags = get(agentData, 'agent_tags', [])
  return agentTags?.[0]?.code || 'Retail'
}

export const getIsRm = (agentData) => {
  if (checkIsRm(agentData)) return true
  if (checkIsLvAdmin(agentData)) return true // treat LV Admin as RM
  if (cookies.get(LOGIN_AS_GURDIAN)) return true // for case where RM logs in using guardian agents
  return false
}
